// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-osm-map',
//   templateUrl: './osm-map.component.html',
//   styleUrls: ['./osm-map.component.css']
// })
// export class OsmMapComponent {

// }

// import {
//   Component,
//   EventEmitter,
//   Input,
//   OnDestroy,
//   OnInit,
//   Output,
//   ViewChild,
// } from '@angular/core';
// import { MatMenuTrigger } from '@angular/material/menu';
// import {
//   Map,
//   Control,
//   DomUtil,
//   ZoomAnimEvent,
//   Layer,
//   MapOptions,
//   tileLayer,
//   latLng,
//   LeafletEvent,
//   icon,
//   marker,
//   LatLng,
//   Icon,
//   IconOptions,
//   MarkerOptions,
//   LayerOptions,
//   Marker,
// } from 'leaflet';

// @Component({
//   selector: 'app-osm-map',
//   templateUrl: './osm-map.component.html',
//   styleUrls: ['./osm-map.component.css'],
// })
// export class OsmMapComponent implements OnInit, OnDestroy {
//   mouseX: number = 0;
//   mouseY: number = 0;
//   @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger | undefined;
//   @Output() map$: EventEmitter<Map> = new EventEmitter();
//   @Output() zoom$: EventEmitter<number> = new EventEmitter();
//   @Input() options: MapOptions = {
//     layers: [
//       tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
//         opacity: 0.7,
//         maxZoom: 19,
//         detectRetina: true,
//         attribution:''
//           // '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
//       }),
//     ],
//     zoom: 15,
//     center: latLng(-22.37855150766163, -41.778323650360115),
//   };
//   public map: Map | undefined;
//   public zoom: number | undefined;
//   markerIconBlue = icon({
//     iconSize: [25, 41],
//     iconAnchor: [10, 41],
//     popupAnchor: [2, -40],
//     // specify the path here
//     iconUrl:
//       'https://raw.githubusercontent.com/raulmu/assets/main/marker-icon-blue.png',
//     shadowUrl: 'https://unpkg.com/leaflet@1.4.0/dist/images/marker-shadow.png',
//   }) as Icon<IconOptions>;
//   markerIconRed = icon({
//     iconSize: [25, 41],
//     iconAnchor: [10, 41],
//     popupAnchor: [2, -40],
//     // specify the path here
//     iconUrl:
//       'https://raw.githubusercontent.com/raulmu/assets/main/marker-icon-red.png',
//     shadowUrl: 'https://unpkg.com/leaflet@1.4.0/dist/images/marker-shadow.png',
//   }) as Icon<IconOptions>;
//   markers: Marker[] = [];
//   menuMarker: Marker | undefined;
//   constructor() {}

//   ngOnInit() {
//     document.addEventListener('mousemove', (e) => {
//       this.mouseX = e.pageX;
//       this.mouseY = e.pageY;
//     });
//     window.addEventListener('resize', (e) => {
//       0;
//       console.log('resize');
//       this.trigger!.closeMenu();
//     });
//   }

//   ngOnDestroy() {
//     if (!this.map) {
//       return;
//     }
//     this.map.clearAllEventListeners;
//     this.map.remove();
//   }

//   onMapReady(map: Map) {
//     this.map = map;
//     this.map.on('click', (e) => {
//       var coord = e.latlng;
//       var lat = coord.lat;
//       var lng = coord.lng;
//       this.addMarker(lat, lng, { icon: this.markerIconBlue });
//     });
//     this.map$.emit(map);
//     this.zoom = map.getZoom();
//     this.zoom$.emit(this.zoom);
//   }

//   onMapZoomEnd(e: LeafletEvent) {
//     this.zoom = e.target.getZoom();
//     this.zoom$.emit(this.zoom);
//   }

//   addMarker(lat: number, lng: number, markerIcon: MarkerOptions) {
//     if (!this.map) {
//       return;
//     }
//     const newMarker = marker([lat, lng], markerIcon)
//       .on('click', (e) => {
//         this.trigger!.closeMenu();
//         let circle = document.getElementById('circle');
//         if (circle && this.mouseX > 5 && this.mouseY > 5) {
//           circle.style.left = this.mouseX + 'px';
//           circle.style.top = this.mouseY + 'px';
//         }
//         this.menuMarker = e.target;
//         this.trigger!.openMenu();
//         if (!this.map) {
//           return;
//         }
//       })
//       .on('mouseover', (e) => {});
//     this.markers.push(newMarker);
//     newMarker.addTo(this.map);
//     this.map.panTo(new LatLng(lat, lng));
//   }

//   remove() {
//     const index = this.markers.findIndex((value) => value == this.menuMarker!);
//     this.markers.splice(index, 1);
//     this.map!.removeLayer(this.menuMarker!);
//   }
//   favoritar() {
//     this.menuMarker!.setIcon(this.markerIconRed);
//   }
//   desfavoritar() {
//     this.menuMarker!.setIcon(this.markerIconBlue);
//   }
//   public clearAll() {
//     alert();
//     this.markers.map((marker) => {
//       this.map!.removeLayer(marker);
//     });
//     this.markers = [];
//   }
// }

// import { Component, OnInit } from '@angular/core';
// import * as L from 'leaflet';
// import { latLng, tileLayer } from 'leaflet';

// @Component({
//   selector: 'app-osm-map',
//   templateUrl: './osm-map.component.html',
//   styleUrls: ['./osm-map.component.css'],
// })
// export class OsmMapComponent implements OnInit {


// //polyline
// private map!: L.Map;
// private markers: L.Marker[] = [];
// private polyline!: L.Polyline;

// ngOnInit(): void {
//   this.initMap();
// }

// private initMap(): void {
//   this.map = L.map('map').setView([51.505, -0.09], 13);

//   // Add OpenStreetMap Tile Layer
//   L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
//     attribution: '&copy; OpenStreetMap contributors'
//   }).addTo(this.map);

//   // Initialize empty polyline
//   this.polyline = L.polyline([], { color: 'blue' }).addTo(this.map);

//   // Click event to add markers and calculate distance
//   this.map.on('click', (event: L.LeafletMouseEvent) => {
//     this.addMarker(event.latlng);
//   });
// }

// private addMarker(latlng: L.LatLng): void {
//   // Add new marker
//   const marker = L.marker(latlng).addTo(this.map).bindPopup(`Marker at ${latlng.lat}, ${latlng.lng}`).openPopup();
//   this.markers.push(marker);

//   // Update polyline with new marker positions
//   this.polyline.addLatLng(latlng);

//   // If there are at least two markers, calculate distance
//   if (this.markers.length > 1) {
//     this.calculateDistance();
//   }
// }

// private calculateDistance(): void {
//   const lastIndex = this.markers.length - 1;
//   const latlng1 = this.markers[lastIndex - 1].getLatLng();
//   const latlng2 = this.markers[lastIndex].getLatLng();

//   const distance = latlng1.distanceTo(latlng2); // Distance in meters
//   const distanceKm = (distance / 1000).toFixed(2); // Convert to km

//   // Show distance popup on the latest marker
//   this.markers[lastIndex]
//     .bindPopup(`Distance from last marker: ${distanceKm} km`)
//     .openPopup();

//   console.log(`Distance between markers: ${distanceKm} km`);
// }
// }

import { Component, OnInit } from '@angular/core';
import * as L from 'leaflet';

// Fix Leaflet missing marker icons
const iconRetinaUrl = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png';
const iconUrl = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png';
const shadowUrl = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png';

const defaultIcon = L.icon({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

// Apply this icon globally
L.Marker.prototype.options.icon = defaultIcon;

@Component({
  selector: 'app-osm-map',
  templateUrl: './osm-map.component.html',
  styleUrls: ['./osm-map.component.css'],
})
export class OsmMapComponent implements OnInit {
  private map!: L.Map;
  private markerLayer = L.layerGroup(); // Markers
  private polylineLayer = L.polyline([], { color: 'blue' }); // Route
  private circleLayer = L.layerGroup(); // Circles
  private polygonLayer = L.layerGroup(); // Polygons

  distances: { point1: string; point2: string; distance: string }[] = []; // Store distances
  private apiUrl = 'https://nominatim.openstreetmap.org/reverse?format=json&lat=';

  ngOnInit(): void {
    this.initMap();
  }

  private initMap(): void {
    // 🌍 Center map on Mumbai
    this.map = L.map('map').setView([19.0760, 72.8777], 12);

    // 🗺 Base Layers
    const osm = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors'
    });

    const satellite = L.tileLayer('https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      attribution: '&copy; Google Satellite'
    });

    const darkMode = L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; Dark Mode'
    });

    osm.addTo(this.map); // Default base map

    // 🏛 Overlay Layers (Markers, Routes, Circles, Polygons)
    this.markerLayer.addTo(this.map);
    this.polylineLayer.addTo(this.map);
    this.circleLayer.addTo(this.map);
    this.polygonLayer.addTo(this.map);

    // 📌 Add Mumbai Landmarks
    this.addMumbaiLandmarks();

    // 🌍 Layer Control
    L.control.layers(
      { 'OpenStreetMap': osm, 'Google Satellite': satellite, 'Dark Mode': darkMode },
      { 'Markers': this.markerLayer, 'Route': this.polylineLayer, 'Circles': this.circleLayer, 'Polygons': this.polygonLayer }
    ).addTo(this.map);

    // 🖱 Click event to add markers
    this.map.on('click', (event: L.LeafletMouseEvent) => {
      this.addMarker(event.latlng);
    });
  }

  private addMarker(latlng: L.LatLng): void {
    const marker = L.marker(latlng).bindPopup(`📍 ${latlng.lat}, ${latlng.lng}`).openPopup();
    this.markerLayer.addLayer(marker);
    this.polylineLayer.addLatLng(latlng);
    this.showDistance();
  }

  // private showDistance(): void {
  //   const latlngs: L.LatLng[] = this.polylineLayer.getLatLngs() as L.LatLng[];

  //   if (latlngs.length < 2) {
  //     console.log("Not enough markers to calculate distance.");
  //     return;
  //   }

  //   let totalDistance = 0;
  //   for (let i = 0; i < latlngs.length - 1; i++) {
  //     totalDistance += latlngs[i].distanceTo(latlngs[i + 1]);
  //   }

  //   console.log(`Total distance: ${(totalDistance / 1000).toFixed(2)} km`);
  // }

  private async getCityName(lat: number, lng: number): Promise<string> {
    try {
      const response = await fetch(`${this.apiUrl}${lat}&lon=${lng}`);
      const data = await response.json();
      return data.address.city || data.address.town || data.address.village || 'Unknown';
    } catch (error) {
      console.error('Error fetching city name:', error);
      return 'Unknown';
    }
  }
  // private showDistance(): void {
  //   const latlngs: L.LatLng[] = this.polylineLayer.getLatLngs() as L.LatLng[];

  //   if (latlngs.length < 2) {
  //     console.log("Not enough markers to calculate distance.");
  //     return;
  //   }

  //   this.distances = []; // Clear previous distances
  //   let totalDistance = 0;

  //   for (let i = 0; i < latlngs.length - 1; i++) {
  //     const distance = latlngs[i].distanceTo(latlngs[i + 1]) / 1000; // Convert to km
  //     totalDistance += distance;

  //     this.distances.push({
  //       point1: `${latlngs[i].lat.toFixed(4)}, ${latlngs[i].lng.toFixed(4)}`,
  //       point2: `${latlngs[i + 1].lat.toFixed(4)}, ${latlngs[i + 1].lng.toFixed(4)}`,
  //       distance: `${distance.toFixed(2)} km`
  //     });
  //   }

  //   console.log(`Total distance: ${totalDistance.toFixed(2)} km`);
  // }
  private async showDistance(): Promise<void> {
    const latlngs: L.LatLng[] = this.polylineLayer.getLatLngs() as L.LatLng[];

    if (latlngs.length < 2) {
      console.log("Not enough markers to calculate distance.");
      return;
    }

    this.distances = []; // Clear previous distances
    let totalDistance = 0;

    for (let i = 0; i < latlngs.length - 1; i++) {
      const distance = latlngs[i].distanceTo(latlngs[i + 1]) / 1000; // Convert to km
      totalDistance += distance;

      // Fetch city names
      const city1 = await this.getCityName(latlngs[i].lat, latlngs[i].lng);
      const city2 = await this.getCityName(latlngs[i + 1].lat, latlngs[i + 1].lng);

      this.distances.push({
        point1: city1,
        point2: city2,
        distance: `${distance.toFixed(2)} km`
      });
    }

    console.log(`Total distance: ${totalDistance.toFixed(2)} km`);
  }

  private addMumbaiLandmarks(): void {
    // 🏛 Mumbai Famous Locations (Polygons & Circles)
    const gatewayOfIndia = L.marker([18.9220, 72.8347]).bindPopup("🕌 Gateway of India");
    const marineDrive = L.marker([18.9455, 72.8234]).bindPopup("🌊 Marine Drive");
    const hajiAli = L.marker([18.9823, 72.8097]).bindPopup("🕌 Haji Ali Dargah");

    // 🏢 Polygon (Example Area)
    const bandraPolygon = L.polygon([
      [19.0630, 72.8350],
      [19.0745, 72.8505],
      [19.0835, 72.8322]
    ], { color: 'green' }).bindPopup("📍 Bandra Area");

    // 🎯 Circle (Mark radius area)
    const airportCircle = L.circle([19.0896, 72.8656], {
      color: 'red',
      fillColor: '#f03',
      fillOpacity: 0.5,
      radius: 2000
    }).bindPopup("✈ Mumbai Airport");

    // Add to Layers
    this.markerLayer.addLayer(gatewayOfIndia);
    this.markerLayer.addLayer(marineDrive);
    this.markerLayer.addLayer(hajiAli);
    this.polygonLayer.addLayer(bandraPolygon);
    this.circleLayer.addLayer(airportCircle);
  }
}

